import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../css/App.css';


const services = [
  {
    icon: "fas fa-truck",
    title: "Trasporti Nazionali",
    description: "Consegne rapide e affidabili in tutta Italia, con massima flessibilità negli orari."
  },
  {
    icon: "fas fa-water",
    title: "Trasporto e Fornitura Acqua",
    description: "Forniamo e trasportiamo acqua per abitazioni private, piscine, enti pubblici e strutture turistiche."
  },
  {
    icon: "fas fa-tint",
    title: "Trasporto Liquidi Alimentari",
    description: "Eseguiamo trasporti nazionali di liquidi alimentari con cisterne coibentate e possibilità di separazione dei liquidi, nel rispetto delle norme."
  },
  {
    icon: "fas fa-ship",
    title: "Trasporto Container",
    description: "Gestiamo container da 20′ e 40′ da e per porti e terminal."
  },
  {
  icon: "fas fa-boxes",
  title: "Trasporto su Pallet",
  description: "Servizio ideale per aziende che necessitano di spedizioni sicure e organizzate."
  },
  {
    icon: "fas fa-snowflake",
    title: "Trasporti Refrigerati",
    description: "Trasporti a temperatura controllata per prodotti alimentari, merci deperibili e beni isotermici."
  }
];


function Services() {
  return (
    <div className="w3-container" id="services" style={{ marginTop: '75px' }}>
      <h1 className="w3-xxxlarge w3-text-black">
        <b>Servizi</b>
      </h1>
      <p className="w3-large w3-text-amber" style={{ marginTop: '-10px', marginBottom: '20px' }}>
        <i><b>Trasportiamo qualsiasi merce ovunque ti serva</b></i>
      </p>
      <hr className="w3-round hr-amber" />

      <Container fluid className="mt-4">
        <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
         Spediamo ogni tipo di merce, anche prodotti a temperatura controllata e trasporti speciali.  
          Il nostro obiettivo è semplificare il processo logistico per le aziende, offrendo soluzioni su 
          misura, rapide e affidabili. 
          Dai trasporti di merci generiche ai trasporti di liquidi, portiamo ovunque ciò di cui hai bisogno,
          rispondendo a ogni esigenza logistica, anche la più complessa. 
        </p>

<Row className="mt-4">
        {services.map((service, index) => (
          <Col md={4} sm={6} key={index} className="mb-4">
            <Card className="h-100 text-center shadow-sm service-card" style={{ borderRadius: '15px', transition: '0.3s' }}>
              <Card.Body>
                <i className={`${service.icon} w3-text-amber`} style={{ fontSize: '2.5rem' }}></i>
                <Card.Title className="mt-3"><b>{service.title}</b></Card.Title>
                <Card.Text style={{ fontSize: '0.95rem' }}>{service.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      { /*

      
        <Row className="text-center mt-5">
          <Col md={4} sm={6} className="mb-4">
            <div style={{ padding: '20px' }}>
              <i className="fas fa-truck w3-text-amber" style={{ fontSize: '2.5rem'}}></i>
              <h5 className="mt-3"><b>Trasporti nazionali</b></h5>
              <p style={{ fontSize: '0.95rem' }}>
                Consegne rapide e affidabili in tutta Italia, con massima flessibilità negli orari.
              </p>
            </div>
          </Col>

          <Col md={4} sm={6} className="mb-4">
            <div style={{ padding: '20px' }}>
              <i className="fas fa-box w3-text-amber" style={{ fontSize: '2.5rem' }}></i>
              <h5 className="mt-3"><b>Trasporto su pallet</b></h5>
              <p style={{ fontSize: '0.95rem' }}>
                Servizio ideale per aziende che necessitano di spedizioni sicure e organizzate.
              </p>
            </div>
          </Col>

          <Col md={4} sm={6} className="mb-4">
            <div style={{ padding: '20px' }}>
              <i className="fas fa-snowflake w3-text-amber" style={{ fontSize: '2.5rem' }}></i>
              <h5 className="mt-3"><b>Trasporti Refrigerati</b></h5>
              <p style={{ fontSize: '0.95rem' }}>
                Offriamo trasporti a temperatura controllata da –25°C a +30°C per prodotti alimentari, merci 
                deperibili e beni che richiedono spedizioni isotermiche, in conformità alla normativa ATP. 
              </p>
            </div>
          </Col>

          <Col md={4} sm={6}>
            <div style={{ padding: '20px' }}>
              <i className="fas fa-ship w3-text-amber" style={{ fontSize: '2.5rem'}}></i>
              <h5 className="mt-3"><b>Trasporto Container</b></h5>
              <p style={{ fontSize: '0.95rem' }}>
                Gestiamo il trasporto su strada di container da 20′ e 40′, da e per terminal container, porti 
               e stazioni ferroviarie.  
              </p>
            </div>
          </Col>

          <Col md={4} sm={6}>
            <div style={{ padding: '20px' }}>
              <i className="fas fa-water w3-text-amber" style={{ fontSize: '2.5rem'}}></i>
              <h5 className="mt-3"><b>Trasporto e Fornitura Acqua</b></h5>
              <p style={{ fontSize: '0.95rem' }}>
                Forniamo e trasportiamo acqua per abitazioni private, piscine, enti pubblici e strutture 
                turistiche. 
                Siamo partner della Protezione Civile, con servizi dedicati alla prevenzione e tutela del 
                territorio.
              </p>
            </div>
          </Col>

          <Col md={4} sm={6}>
            <div style={{ padding: '20px' }}>
              <i className="fas fa-tint w3-text-amber" style={{ fontSize: '2.5rem'}}></i>
              <i class="fa-solid fa-bottle-droplet"></i>
              <h5 className="mt-3"><b>Trasporto Liquidi Alimentari</b></h5>
              <p style={{ fontSize: '0.95rem' }}>
                Eseguiamo trasporti nazionali e internazionali di liquidi alimentari con cisterne coibentate 
                e possibilità di separazione dei liquidi, nel rispetto della normativa ATP. 
              </p>
            </div>
          </Col>
        </Row>

      */}
      </Container>
    </div>
  );
}

export default Services;
